import { Button, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Stack align="flex-start">
      <Title order={2}>Page introuvable</Title>
      <Text c="dimmed">L'adresse demandée n'existe pas ou a été déplacée.</Text>
      <Button component={Link} to="/">
        Retour à l'accueil
      </Button>
    </Stack>
  );
}
